import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/customers/recommendations')({
  component: RecommendationsPage,
});

function RecommendationsPage() {
  return (
    <div className="p-6">
      <h1 className="text-xl font-semibold">Job Recommendations Management</h1>
      <p className="text-muted-foreground text-sm">
        Manually assign jobs to customers when AI matching needs human oversight or bulk assignment.
      </p>
    </div>
  );
}
